import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateFacturationMode } from '../../api/TICKET/ticketMeta';
import { toast } from 'react-toastify';

export const useUpdateFacturationMode = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ modeId, modeData }) => updateFacturationMode(modeId, modeData),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['facturationModes'] });
            toast.success('Méthode de facturation modifiée avec succès');
        },
        onError: (error) => {
            toast.error(error.message || 'Erreur lors de la modification de la méthode de facturation');
        },
    });
};
